import React, { useState, useEffect } from 'react';
import { BarChart3, FileText, Calendar, TrendingUp, Plus,  AlertTriangle } from 'lucide-react';
import Overview from '../../components/leaves/Overview';
import Requests from '../../components/tables/LeaveRequests';
import CalendarView from '../../components/leaves/Calendar';
import Analytics from '../../components/leaves/Analytics';
import LeaveDetailsModal from '../../components/DViews/LeaveDetailsModal';
import DayDetailsModal from '../../components/leaves/DayDetailsModal';
import {  CircularProgress, ThemeProvider, useMediaQuery, Fab, Typography, Box } from '@mui/material';
import '../../components/leaves/Leaves.css';
import { monthNames } from '../../components/leaves/constants';
import { getPendingRequestsOlderThan15Days, getApprovedLeaves, getAllLeaves, getSickLeaves, approveLeave, rejectLeave, getLeavesPerDepartment, getMyLeaves } from '../../services/leavesAPIs';
import {getAllEmployees} from '../../services/EmployeeService';
import LeaveBalanceManager from '../Payroll/LeaveBalance.jsx';
import ToggleHeader from '../../components/headers/ToggleHeader.jsx';
import JustificationUploadModal from '../../components/DViews/JUModal.jsx';

import { useRef } from 'react';

const NotEmployee = localStorage.getItem('userRole')!=='EMPLOYEE';

const Vacation = () => {
  const [IsEmployee,setIsEmployee]=useState(localStorage.getItem('userRole')==='EMPLOYEE');
  
  const modalRef = useRef(null);
  const rejectionDialogRef = useRef(null);
  const isLargeScreen = useMediaQuery('(min-width: 1600px)');

  const lb='handleWithEmployeeId';
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [leavesData, setLeavesData] = useState([]);
  const [unpaidLeave, setUnpiadLeave] = useState([]);
  const [approved, setApproved] = useState([]);
  const [pending, setPending] = useState([]);
  const [urgentRequests, setUrgentRequests] = useState([]);
  const [hasUrgentRequests, setHasUrgentRequests] = useState(false);
  const [currentDate] = useState(new Date('2025-06-19T10:26:00+01:00'));
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(currentDate.getFullYear());
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedLeaveId, setSelectedLeaveId] = useState(null);

  const [activeTab, setActiveTab] = useState(IsEmployee ? 'EmpRequest' : 'newOverview');
   
  const [selectedUpload, setSelectedUpload] = useState(null);

  const [filters, setFilters] = useState({
    type: '',
    status: '',
    department: '',
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    search: ''
  });

  const [dashboardFilters, setDashboardFilters] = useState({
    periodType: 'year', // or 'month'
    periodValue: new Date().getFullYear().toString(), // e.g., "2025" or "2025-06"
    office: 'All',
  });
  const [showEmployeeCard, setShowEmployeeCard] = useState(false);

  //Toggle Header
  const [activeView, setActiveView] = useState('approved');
  const leaveViews = [
    { id: 'approved', title: 'Vacations'},
    { id: 'unpaid', title: 'Unpaid Vacation'},
    { id: 'leaveBalance', title: 'Leave Blance' }
  ];

    // Determine which data to show
  const getCurrentData = () => {
    switch (activeView) {
      case 'approved':
        return approved;
      case 'unpaid':
        return unpaidLeave;
    }
  };

  // PDF states
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // Data fetching - update the useEffect
  const fetchData = async () => {
    setLoading(true);
    let allLeavesData = [];
    try {
     
      allLeavesData = await getAllLeaves();
      // Filter: only "Annual Leave"
      const annualLeaves = allLeavesData.filter(leave => 
        leave.type === 'ANNUAL_LEAVE'
      );
      const urgentRequestsData = await getPendingRequestsOlderThan15Days();
      const filteredUrgent = urgentRequestsData.filter(leave => 
        leave.type === 'ANNUAL_LEAVE'
      );
      const approvedL= await getApprovedLeaves();
      const filteredApproved = approvedL.filter(leave => 
        leave.type === 'ANNUAL_LEAVE'
      );
      const unpaidLeaves = approvedL.filter(leave => 
        leave.type === 'UNPAID_LEAVE'
      );

      setLeavesData(annualLeaves);
      setUrgentRequests(filteredUrgent);
      setHasUrgentRequests(filteredUrgent.length > 0);
      setApproved(filteredApproved);
      setUnpiadLeave(unpaidLeaves);

      const allEmployees = await getAllEmployees();
      setEmployees(allEmployees);
        
      console.log("Urgent Requests:", urgentRequestsData);
      console.log("All Leaves:", allLeavesData);
      console.log("All Employees:", allEmployees);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading to false
    }
  };

  useEffect(() => {
    fetchData();
  }, [IsEmployee]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectedLeaveId &&
        modalRef.current &&
        !modalRef.current.contains(event.target)&&
      (!rejectionDialogRef.current || !rejectionDialogRef.current.contains(event.target))
    ) {
        setSelectedLeaveId(null);
      }
      if (
        selectedDay &&
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        setSelectedDay(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [selectedLeaveId, selectedDay]);

  useEffect(() => {
    if (IsEmployee) {
      setActiveTab('EmpRequest'); // or 'absences', depending on your desired default
    } else if (!IsEmployee) {
      setActiveTab('newOverview'); // Set to 'overview' when switching to non-employee
    }
  }, [IsEmployee]);
  
  const handleEmployeeSelect = (id) => {
    setSelectedEmployeeId(id);
    setShowEmployeeCard(false);
    console.log('Selected employee ID:', id);
  };

  const handleStatusCardClick = (status) => {
  const { periodType, periodValue } = dashboardFilters;

  let year, month;
  if (periodType === 'year') {
    year = parseInt(periodValue);
    month = null;
  } else {
    const [yearStr, monthStr] = periodValue.split('-');
    year = parseInt(yearStr, 10);
    month = parseInt(monthStr, 10); // Must parse as int!
  }

  setFilters(prev => ({
    ...prev,
    status,
    department: '',
    type: '',
    year,      // <-- ADD THIS
    month,     // <-- ADD THIS
    //office: dashboardFilters.office, // Optional sync
    office: dashboardFilters.office === 'All' ? '' : dashboardFilters.office,
  }));
  setActiveTab('requests');
};



  return (
    <div>
      <ToggleHeader 
        views={leaveViews}
        activeView={activeView}
        onViewChange={setActiveView}
      />
         { (activeView=='approved') &&  
          <Requests
            leavesData={getCurrentData()}
            filters={filters}
            setFilters={setFilters}
            setSelectedLeave={setSelectedLeaveId}
            setLeavesData={setLeavesData}
            IsEmployee={IsEmployee}
            fetchData={fetchData}
            setSelectedUpload={setSelectedUpload}
          />
          }
          { (activeView=='unpaid') &&  
          <Requests
            leavesData={getCurrentData()}
            filters={filters}
            setFilters={setFilters}
            setSelectedLeave={setSelectedLeaveId}
            setLeavesData={setLeavesData}
            IsEmployee={IsEmployee}
            fetchData={fetchData}
            setSelectedUpload={setSelectedUpload}
            unpaid={true}
          />
          }
          { activeView=='leaveBalance' && <LeaveBalanceManager/>}
          
        
        {selectedLeaveId && (
          <LeaveDetailsModal
            leaveId={selectedLeaveId}
            setSelectedLeave={(val) => {
            console.log('Set selectedLeaveId to:', val); // Debug
            setSelectedLeaveId(val);
           }}
            setLeavesData={setLeavesData}
            modalRef={modalRef}
            rejectionDialogRef={rejectionDialogRef}
            IsEmployee={IsEmployee}
          />
        )}
        {selectedUpload && (
          <JustificationUploadModal
            selectedUpload={selectedUpload}
            setSelectedUpload={(val) => {
            setSelectedUpload(val);
           }}
            fetchData={fetchData}
            leave={true}
          />
        )} 
      
    </div>
  );
};

export default Vacation;